<template>
    <div class="lp-location__pin">
        <svg width="100%" height="100%" viewBox="0 0 293 423" :fill="backgroundColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M293 146.482C293 227.382 146.5 423 146.5 423C146.5 423 0 227.382 0 146.482C0 65.5824 65.5903 0 146.5 0C227.41 0 293 65.5824 293 146.482Z" :fill="backgroundColor" :stroke="borderColor" stroke-width="15"/>
            <image v-if="iconUrl" :href="iconUrl" width="200" height="200" x="47" y="47" />
        </svg>
    </div>
</template>

<script>
        export default {
        name: 'LocationPin',
        props: {
            iconUrl: {
                type: String,
                required: false
            },
            backgroundColor: {
                type: String,
                required: true
            },
            borderColor: {
                type: true,
                required: false
            }
        },
    };
</script>

<style lang="scss" scoped></style>
